<template>
  <section>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Add Note</p>
      </header>
      <section class="modal-card-body">
        <input
          class="input"
          type="textarea"
          maxlength="256"
          v-model="note"
          placeholder="Enter your note"
          v-bind:expanded="true"
          required
          v-focus
          @keyup.enter="() => { createNote(); $parent.close() }"
        />
      </section>
      <footer class="modal-card-foot">
        <button
          class="button"
          type="button"
          @click="$parent.close()"
        >Cancel</button>
        <button
          class="button is-primary"
          @click="() => { createNote(); $parent.close() }"
        >Save</button>
      </footer>
    </div>
  </section>
</template>

<script>
import store from "@/store";

export default {
  props: {
    propertyId: String,
    stage: String
  },
  data() {
    return {
      note: ""
    };
  },
  methods: {
    createNote() {
      var propertyId = this.propertyId;
      var stage = this.stage;
      var note = this.note;
      store.dispatch("newPropertyNote", {
        propertyId,
        stage,
        note
      });
    }
  },
  mounted() {
    console.info("note is " + this.note);
  }
};
</script>

<style>
</style>
